export function parseSlug(slug: string[]) {
  // Use pop() to retrieve the last item
  return slug.length === 2 ? slug[1].split("_").pop() : null;
}
